import Axios from 'axios';
import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { SystemSettingItem, SystemSettingsState } from './types';

export const actions: ActionTree<SystemSettingsState, RootState> = {
  getSystemSettings: async ({commit}, data) => {
    commit('setLoading', true);
    try {
      let resp = await Axios({url: '/acapi/settings', params: data});
      commit('setSystemSettings', resp.data.settings);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  getSystemSettingItem: async ({commit}, id) => {
    commit('setLoading', true);
    try {
      let resp = await Axios({url: `/acapi/settings/${id}`});
      let systemSettingItem = <SystemSettingItem> resp.data;
      systemSettingItem.id = id;
      commit('setSystemSettingItem', systemSettingItem);
      return systemSettingItem;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  saveSystemSettingItem: async ({commit, dispatch}, data: SystemSettingItem) => {
    commit('setLoading', true);
    try {
      let resp = await Axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/settings/' + (data.id ?? ''),
        data: data
      });
      dispatch('getSystemSettings');
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  deleteSystemSettingItem: async ({commit, dispatch}, data: SystemSettingItem) => {
    commit('setLoading', true);
    try {
      let resp = await Axios({
        method: 'delete',
        url: `/acapi/settings/${data.id}`,
        data: data
      });
      dispatch('getSystemSettings');
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  syncCaches: async ({commit}) => {
    commit('setLoading', true);
    try {
      let resp = await Axios({
        method: 'get',
        url: '/acapi/caches/sync',
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  syncTemplates: async ({commit}) => {
    commit('setLoading', true);
    try {
      let resp = await Axios({
        method: 'get',
        url: '/acapi/caches/templates/sync',
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  }
};